// extracted by mini-css-extract-plugin
export default {"zoomControls":"Eqa-z","zoomControlButton":"Fqa-z","zoomBanner":"Gqa-z","bannerButton":"Hqa-z","imageButton":"Iqa-z"};